import OfferListContainer from '../../../../Componant/Application/Ecommerce/master/OfferListContainer'

const OfferList = () => {
  return (
    <div className='page-body'>
      <OfferListContainer />
    </div>
  )
}

export default OfferList